import React__default from 'react';
import { Heading } from '@grandvisionhq/elements';
import { PurchaseTypeSelectionBox } from './PurchaseTypeSelectionBox.js';
import { pushPurchaseTypeSelectionEvent } from '../../../Analytics/events/subscription-events.js';
import { useCmsData } from '../../../../context/CmsContext.js';
import { isSubscriptionPurchase } from '../../../../types/typeguards.js';
import { SUBSCRIPTION_PURCHASE, SINGLE_PURCHASE } from '../../../../types/purchase-types.js';

const PurchaseTypeSelectionBoxes = /*#__PURE__*/ React__default.memo(({ className , purchaseTypePrices , selectedPurchaseType , subscriptionTypeAllowed , onSelection  })=>{
    const { purchaseTypeDocument  } = useCmsData();
    if (!purchaseTypeDocument) {
        return null;
    }
    const { purchaseTypes , title  } = purchaseTypeDocument;
    const subscriptionTypeIndex = purchaseTypes.findIndex((type)=>isSubscriptionPurchase(type.key)
    );
    // If the subscription type is not allowed, remove it from the purchase types list
    subscriptionTypeIndex > -1 && !subscriptionTypeAllowed ? purchaseTypes.splice(subscriptionTypeIndex, 1) : null;
    // Do not show the purchase type selection boxes if there is only one purchase type
    if (purchaseTypes.length < 2) {
        return null;
    }
    const handleOnSelection = React__default.useCallback((purchaseTypeKey)=>{
        onSelection(purchaseTypeKey);
        pushPurchaseTypeSelectionEvent(purchaseTypeKey);
    }, []);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: className
    }, title && /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, title), /*#__PURE__*/ React__default.createElement("fieldset", {
        "aria-label": title
    }, purchaseTypes.map((purchaseType)=>/*#__PURE__*/ React__default.createElement(PurchaseTypeSelectionBox, {
            key: purchaseType.key,
            value: purchaseType.key,
            title: purchaseType.title,
            description: purchaseType.description,
            onChange: handleOnSelection,
            isSelected: purchaseType.key === selectedPurchaseType,
            badgePrice: isSubscriptionPurchase(purchaseType.key) ? purchaseTypePrices[SUBSCRIPTION_PURCHASE] : purchaseTypePrices[SINGLE_PURCHASE]
        })
    )));
});

export { PurchaseTypeSelectionBoxes };
//# sourceMappingURL=PurchaseTypeSelectionBoxes.js.map
